// Module
var code = `<div class="slide-wrapper slide-comparison-type">
    <div class="accent-bar"></div>

    <div class="title-zone">
        <h1>{{title}}</h1>
    </div>

    <div class="content-zone">
        <div class="left-column">
            <div class="column-card left-card">
                <p class="column-title">{{left_column.title}}</p>
                <div class="items-list">
                    {{#content.left_column.items}}
                    <p class="item">✓ {{.}}</p>
                    {{/content.left_column.items}}
                </div>
            </div>
        </div>

        <div class="arrow-separator">
            <p>→</p>
        </div>

        <div class="right-column">
            <div class="column-card right-card">
                <p class="column-title">{{right_column.title}}</p>
                <div class="items-list">
                    {{#content.right_column.items}}
                    <p class="item">→ {{.}}</p>
                    {{/content.right_column.items}}
                </div>
            </div>
        </div>
    </div>
</div>
`;
// Exports
module.exports = code;